export default __webpack_public_path__ + "static/media/Job-Search-Filled.6171e0c6.svg";